<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/useradmin/listusers" class="blue-grey-text text-darken-4 strong">Users</router-link>
        >
        <span>Add User</span>
      </section>
    </article>
    <h4>Add User</h4>
    <article class="row">
      <section class="input-field col s4">
        <input type="text"
               placeholder="jsmith@fool.com"
               class="validate"
               v-model="payload.email"
        >
        <label class="active">Email (required)</label>
      </section>
      <section class="input-field col s4">
        <input id="add-user-start-date"
               type="text" class="datepicker"
               @change="payload.start_date = $event.target.value"
        >
        <label class="active">Start Date (required)</label>
      </section>
      <section class="input-field col s2">
        <label>
          <input type="checkbox"
                 class="filled-in"
                 v-model="payload.is_tester"
          >
          <span>Is Tester</span>
        </label>
      </section>
      <section class="input-field col s2">
        <label>
          <input type="checkbox"
                 class="filled-in"
                 v-model="payload.is_active"
          >
          <span>Is Active</span>
        </label>
      </section>
    </article>
    <article class="row">
        <h5>Assign Analyst Type</h5>
        <div v-for="role in requiredRoles" :key="role.id" class="col s4">
          <div class="card horizontal">
            <div class="card-stacked">
              <div class="card-content">
                  <label>
                    <input type="radio" :value="role.name" v-model="payload.analystType">
                    <span class="strong">{{ role.name }}</span>
                  </label>
              </div>
            </div>
          </div>
        </div>
    </article>
    <article class="row">
        <h5>Assign Roles</h5>
        <div v-for="role in nonRequiredRoles" :key="role.id" class="col s4">
          <div class="card horizontal">
            <div class="card-stacked">
              <div class="card-content">
                  <label>
                    <input type="checkbox" class="filled-in" :value="role.name" v-model="payload.roles">
                    <span class="strong">{{ role.name }}</span>
                    <span class="helper teal-text text-lighten-3" v-if="['analyst', 'farm-team', 'adp'].includes(role.name)"> *required</span>
                  </label>
                  <p>{{ role.description }}</p>
              </div>
            </div>
          </div>
        </div>
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn waves-effect waves-light teal accent-4 right"
               type="submit"
               value="Submit"
               @click.prevent="saveUser"
        >
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AddUser',
  props: {},
  data() {
    return {
      roles: [],
      payload: {
        email: '',
        analystType: 'analyst',
        roles: [],
        is_tester: false,
        is_active: true,
        start_date: '',
      },
      validationErrorMessage: 'Please populate all required fields',
    };
  },
  computed: {
    requiredRoles() {
      return this.roles.filter(role => ['analyst', 'farm-team', 'adp'].includes(role.name));
    },
    nonRequiredRoles() {
      return this.roles.filter(role => !['analyst', 'farm-team', 'adp'].includes(role.name))
    },
  },
  watch: {},
  methods: {
    resetForm() {
      this.payload.email = '';
      this.payload.roles = [];
      this.payload.is_tester = false;
      this.payload.is_active = true;
      this.payload.start_date = '';
      this.payload.analystType = 'analyst';
      document.getElementById('add-user-start-date').value = '';
    },
    validateForm() {
      return ([
        this.payload.email,
        this.payload.roles.length,
        this.payload.start_date,
      ].every(arg => Boolean(arg)));
    },
    async fetchRoles() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/analysts/roles/`);
      this.roles = data.filter(role => role.managers.filter(manager => this.$auth.user.roles.includes(manager)).length);
    },
    async saveUser() {
      if (!this.validateForm()) {
        return this.toast(this.validationErrorMessage, 'pink');
      }
      const { data } = await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/analysts/analyst/`, {
        ...this.payload,
        onboarder_id: this.$auth.user.pk,
        roles: [this.payload.analystType].concat(this.payload.roles),
      });
      await this.$store.dispatch('fetchAnalysts');
      this.toast(`Added ${data.name} to Fool IQ!`, 'green');
      this.resetForm();
    },
    initDatepicker() {
      this.materialize.Datepicker.init(document.querySelectorAll('.datepicker'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        showClearBtn: true,
        onSelect() {},
      });
    },
  },
  async mounted() {
    await this.fetchRoles();
    this.initDatepicker();
  },
};
</script>
